import { money } from '../../lib/format';

interface Props {
  /** Label and amount in paise; pass deductions as negative amounts. */
  readonly rows: ReadonlyArray<readonly [label: string, paise: number]>;
}

export default function PriceBreakdown({ rows }: Props) {
  return (
    <dl>
      {rows.map(([label, paise]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{money(paise)}</dd>
        </div>
      ))}
    </dl>
  );
}
